import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { WhyItHappens } from './components/WhyItHappens';
import { WhatItIs } from './components/WhatItIs';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Results } from './components/Results';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '741445578526747');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-bg text-charcoal font-sans selection:bg-navy/15 selection:text-charcoal" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <WhyItHappens data-id="element-3" />
        <WhatItIs data-id="element-4" />
        <Solution data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <Results data-id="element-7" />
        <FAQ data-id="element-8" />
        <Offer data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <StickyMobileCTA data-id="element-11" />
    </div>;
}